

export class SimCardStatusInput implements ISimCardStatusInput {
    /** The auto-generated id of the sim card details master */
    simCardDetailsId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ISimCardStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.simCardDetailsId = _data["simCardDetailsId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SimCardStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new SimCardStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simCardDetailsId"] = this.simCardDetailsId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ISimCardStatusInput {
    /** The auto-generated id of the sim card details master */
    simCardDetailsId: number;
    /** The updated status */
    status: number;
}

